import styled from 'styled-components';
import { BoxProps, ItemProps } from './interfaces';

const Row = styled.div<BoxProps & ItemProps>`
  display: flex;
  flex-direction: row;
  flex-wrap: ${(props) => props.flexWrap};
  justify-content: ${(props) => props.justifyContent ?? 'flex-start'};
  align-items: ${(props) => props.alignItems ?? null};
  flex-grow: ${(props) => props.flexGrow ?? 0};
  flex-shrink: ${(props) => `${props.flexShrink}`};
  flex-basis: ${(props) => props.flexBasis};
  overflow: ${(props) => props.overflow ?? 'auto'};
  width: ${(props) => props.width};
  cursor: ${(props) => props.cursor};
  height: ${(props) => props.height};
  padding: ${(props) => props.padding};
  background-color: ${(props) => props.backgroundColor};
  align-self: ${(props) => props.alignSelf ?? 'auto'};

  &: hover {
    cursor: ${(props) => (props.onClick ? 'pointer' : undefined)};
  }
`;

export default Row;
